<form class="automation-form" [formGroup]="form" (ngSubmit)="submit()">
  <button type="button" class="automation-form__back" (click)="cancel()">
    <i class="fas fa-arrow-left" aria-hidden="true"></i>
    Voltar para automações
  </button>

  <h2 class="automation-form__title">
    {{ isEditing ? 'Editar automação' : 'Nova automação' }}
  </h2>
  <p class="automation-form__subtitle">
    {{
      isEditing
        ? 'Ajuste o que a AyA faz ou quando ela executa.'
        : 'Dê um nome, diga o que a AyA deve fazer e com que frequência.'
    }}
  </p>

  <div
    class="automation-form__field"
    [class.automation-form__field--invalid]="
      submitted && form.get('title')?.invalid
    "
  >
    <label class="automation-form__label" for="automation-title">Título</label>
    <input
      #titleInput
      id="automation-title"
      type="text"
      class="automation-form__input"
      formControlName="title"
      [maxlength]="titleMaxLength"
      placeholder="Ex: Resumo semanal da carteira"
    />
    <span class="automation-form__error" *ngIf="submitted && form.get('title')?.invalid">
      Dê um título para a automação.
    </span>
  </div>

  <div
    class="automation-form__field"
    [class.automation-form__field--invalid]="
      submitted && form.get('description')?.invalid
    "
  >
    <label class="automation-form__label" for="automation-desc">Descrição</label>
    <textarea
      id="automation-desc"
      class="automation-form__textarea"
      formControlName="description"
      [maxlength]="descriptionMaxLength"
      placeholder="Descreva o que a AyA deve fazer a cada execução…"
    ></textarea>
    <span class="automation-form__help">É isto que a AyA vai executar.</span>
    <span
      class="automation-form__error"
      *ngIf="submitted && form.get('description')?.invalid"
    >
      Diga o que a AyA deve fazer.
    </span>
  </div>

  <p class="automation-form__subhead">Periodicidade</p>
  <div class="automation-form__presets" role="radiogroup" aria-label="Periodicidade">
    <button
      type="button"
      class="automation-form__preset"
      *ngFor="let option of presetOptions"
      role="radio"
      [attr.aria-checked]="selectedPreset === option.preset"
      [class.automation-form__preset--on]="selectedPreset === option.preset"
      (click)="selectPreset(option.preset)"
    >
      {{ option.label }}
    </button>
  </div>

  <div class="automation-form__daypills" *ngIf="showWeekdays">
    <button
      type="button"
      class="automation-form__daypill"
      *ngFor="let weekday of weekdayButtons"
      [class.automation-form__daypill--on]="isDaySelected(weekday.day)"
      (click)="toggleDay(weekday.day)"
    >
      {{ weekday.label }}
    </button>
  </div>

  <div class="automation-form__fine">
    <div
      class="automation-form__field automation-form__field--inline"
      *ngIf="showMonthDay"
      [class.automation-form__field--invalid]="dayOfMonthInvalid"
    >
      <label class="automation-form__label" for="automation-monthday">Dia do mês</label>
      <input
        id="automation-monthday"
        type="text"
        inputmode="numeric"
        class="automation-form__input automation-form__input--compact"
        formControlName="dayOfMonth"
        sgtNumbersOnly
        [maxlength]="2"
      />
      <span class="automation-form__error" *ngIf="dayOfMonthInvalid">
        Escolha um dia entre 1 e 28.
      </span>
    </div>

    <div
      class="automation-form__field automation-form__field--inline automation-form__field--time"
    >
      <label class="automation-form__label" for="automation-time">Horário</label>
      <input
        id="automation-time"
        type="time"
        class="automation-form__input automation-form__input--compact"
        formControlName="time"
      />
    </div>
  </div>

  <p class="automation-form__summary">
    <i class="far fa-clock" aria-hidden="true"></i>
    <span>Executa <b>{{ summary }}</b>.</span>
  </p>

  <div class="automation-form__footer">
    <button
      type="button"
      class="btn btn-ghost automation-form__cancel"
      (click)="cancel()"
    >
      Cancelar
    </button>
    <button
      type="submit"
      class="btn btn-primary"
      [disabled]="isSaving || form.invalid"
    >
      {{ isEditing ? 'Salvar alterações' : 'Salvar automação' }}
    </button>
  </div>
</form>
